import React, { useContext, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import AuthContext from "../../context/auth/authContext";
import Alert from "../layouts/Alert";
import "../../styles/fonts.css";
const Login = (props) => {
  const authContext = useContext(AuthContext);
  const { loginUser, isAuthenticated, googleLogin } = authContext;
  useEffect(() => {
    if (isAuthenticated) {
      props.history.push("/"); //redirect
    }

    //eslint-disable-next-line
  }, [isAuthenticated, props.history]);

  const [user, setUser] = useState({
    email: "",
    password: "",
  });

  const { email, password } = user;

  const onChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    loginUser({ email, password });
  };

  const google = () => {
    googleLogin();
  };
  return (
    <div>
      <h1 class='mb-4 upperfont'>Login</h1>
      <hr></hr>
      <Alert />
      <form onSubmit={onSubmit}>
        <div class=' form-group'>
          <label htmlFor='login-email ' className="fontcool">Email address</label>
          <input
            type='email'
            className='form-control simplefont'
            name='email'
            id='login-email'
            aria-describedby='emailHelp'
            onChange={onChange}
          />
        </div>
        <div class='form-group'>
          <label htmlFor='login-password '  className="fontcool">Password</label>
          <input
            type='password'
            className='form-control simplefont'
            id='login-password'
            name='password'
            onChange={onChange}
          />
          <small className="simplefont">
            Forgot Password?{" "}
            <Link to='/resetPass'>Reset Password on your email</Link>
          </small>
        </div>
        <button type='submit' className='btn btn-dark btn-block slantfont'>
          Login
        </button>
        <br></br>
        <h6 className='simplefont text-center'>- OR -</h6>
        <br></br>
        <button className='slantfont btn btn-danger btn-block ' onClick={google}>
          <i className=' fab fa-google left'></i>
          Log In With Google
        </button>
      </form>
      <hr></hr>
      <span className="simplefont">Don't have an account? <Link to='/register' >Signup here</Link></span>
    </div>
  );
};

export default Login;
